// src/auth/msalConfig.js
import { PublicClientApplication } from "@azure/msal-browser";



const msalConfig = {  

  auth: {
    // clientId: process.env.REACT_APP_CLIENT_ID,
    // authority: `https://login.microsoftonline.com/$process.env.REACT_APP_TENANT_ID}`,
    // redirectUri: process.env.REACT_APP_REDIRECT_URI
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you're having issues on IE11 or Edge
  }
};

// Create a PublicClientApplication instance
const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;


// import { PublicClientApplication } from "@azure/msal-browser";

// // Export a function that returns a Promise
// const initializeMsal = async () => {
  
//   const response = await fetch("/config.json");
//   console.log("response for client id", response.json());
//   if (!response.ok) throw new Error("Failed to load config.json");
//   const config = await response.json();

//   const msalConfig = {
//     auth: {
//       clientId: config.clientId,
//       authority: config.authority,
//       redirectUri: config.redirectUri,
//     },
//     cache: {
//       cacheLocation: "sessionStorage",
//       storeAuthStateInCookie: false,
//     }
//   };

//   return new PublicClientApplication(msalConfig);
// };

// export default initializeMsal;